import { COLOR_BASE_GREY_60 } from '@audi/audi-ui-design-tokens';
import styled from 'styled-components';
import { breakPoints, customBreakPoint, mobileBreakPoint } from '~/styles/break-points';

export const ImageComparisorStyle = styled.div<{ $aspectRatio?: string }>`
	width: 100%;
	height: 100%;
	aspect-ratio: ${(props) => (props.$aspectRatio ? `${props.$aspectRatio} !important` : '4 / 3')};
	position: relative;
	overflow: hidden;

	${customBreakPoint(
		mobileBreakPoint,
		`
			aspect-ratio: 15 / 9;
		`,
	)}

	.comparison-information {
		background: #fff;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: right;
		justify-content: flex-end;
		> p {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 50%;
			color: ${COLOR_BASE_GREY_60};
			font-weight: bold;
			line-height: 1.5;
			font-size: 10px;
			padding: 40px;
			text-align: center;
			${breakPoints({
				'768': `
					padding: 0;
				`,
			})}
		}
	}
`;
